import apiFetch from '../../apiFetch'

export default function (campaign, token, lastAccessDate) {
  return apiFetch({ endPoint: 'dossier/campaign', method: 'PUT', body: campaign, token: token, lastAccessDate })
}
